
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
// import { seeding_modifying_list } from '../lib/modifying';

const { VUE_APP_FCAPI: FCAPI } = process.env;
const Hundun = namespace('Hundun');
const API = {
  get_list: `${FCAPI}/boss/hundun/datacenter/user`,
  teacher_get_list: `${FCAPI}/boss/hundun/setting/teacher`
};

@Component
export default class MissionDetail extends Vue {
  /* eslint-disable */
  // @ts-ignore
  @Hundun.State('teacher_list') teacher_list: any; //负责班主任
  // @ts-ignore
  @Hundun.State('branch_office') branch_office: any; //分社选项
  // @ts-ignore
  @Prop({ default: false }) visible: boolean;
  @Prop({ default: () => [] }) form_list: any;
  @Prop({ default: '批量修改' }) title: any;
  @Prop({ default: 0 }) type: any;

  // modifying_info_list: any = this.form_list;
  form: any = this.$form.createForm(this, { name: 'dialog_form' });
  deleteOption(item: any, key: number) {
    console.log(item);
    // if(item[key].id)

    item.splice(key, 1);
  }
  addDefined(type: string, item?: any) {
    if (type == 'label') {
      this.form_list.push({ name: '', type: 1, options: [{ value: undefined }] });
    } else {
      item.options.push({ value: undefined });
    }
  }
  // 确认按钮
  handleOk() {
    const send_data = JSON.parse(JSON.stringify(this.form_list));
    console.log(send_data);

    send_data.forEach((element: any) => {
      element.options = element.options.map((item: any) => item.value).join();
      // if (element.type == 1) delete element.options;
    });
    console.log(send_data);

    this.$emit('handleOk', send_data, this.type);
  }
  // 取消按钮;
  handleCancel() {
    this.$emit('handleCancel', this.form_list, this.type);
  }
}
